import { ChangeEvent, useState } from 'react'
import { ResultView } from './views/ResultView'
import Ad from './views/Ad'

const App = () => {
  // #region フック

  const [mapRank, setMapRank] = useState<number>(0xb5)

  const [mapSeed, setMapSeed] = useState<string>('3CA2')

  const [result, setResult] = useState<JSX.Element>(
    <ResultView mapRank={mapRank} mapSeed={parseInt(mapSeed, 16)} />
  )

  const [is234] = useState(() => Math.random() < 0.5)

  // #endregion フック

  // #region スタイル

  const adAreaStyle: React.CSSProperties = {
    textAlign: 'center'
  }

  const adHeadlineStyle: React.CSSProperties = {
    margin: '8px 0 0 0',
    fontSize: '20px',
    fontFamily: 'Meiryo',
    fontWeight: 'bold'
  }

  const adMainStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center'
  }

  const hrStyle: React.CSSProperties = {
    marginLeft: '18px'
  }

  const spaceStyle: React.CSSProperties = {
    marginLeft: '10px'
  }

  const mapRankPulldownStyle: React.CSSProperties = {
    fontSize: '15px',
    width: '150px',
    height: '24px'
  }

  const mapSeedTextStyle: React.CSSProperties = {
    height: '20px'
  }

  const resultStyle: React.CSSProperties = {
    backgroundColor: '#FFFFFF',
    width: '300px',
    height: '400px',
    border: 'solid 1px',
    overflowY: 'scroll'
  }

  // #endregion スタイル

  // #region イベント

  const onMapRankChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setMapRank(parseInt(e.target.value))
  }

  const onMapSeedChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.target.value = e.target.value.replace(/[^a-fA-F\d{0}]/g, '').toUpperCase()
    setMapSeed(e.target.value)
  }

  const onSearchClick = () => {
    if (mapSeed === '') {
      setResult(<></>)
      return
    }
    setResult(<ResultView mapRank={mapRank} mapSeed={parseInt(mapSeed, 16)} />)
  }

  // #endregion イベント

  const mapRankList = [0x02, 0x38, 0x3d, 0x4c, 0x51, 0x65, 0x79, 0x8d, 0xa1, 0xb5, 0xc9, 0xdd]

  return (
    <>
      <div style={adAreaStyle}>
        <p style={adHeadlineStyle}>広告</p>
        {is234 ? (
          <div style={adMainStyle}>
            <Ad width={234} height={60} />
            <Ad width={234} height={60} />
            <Ad width={234} height={60} />
          </div>
        ) : (
          <div style={adMainStyle}>
            <Ad width={468} height={60} />
            <Ad width={468} height={60} />
          </div>
        )}
      </div>
      <hr style={hrStyle} />
      <div style={spaceStyle}>
        <h1>ドラゴンクエスト9 宝の地図簡易検索ツール</h1>
        <div style={spaceStyle}>
          地図ランク・地図シードから宝の地図の情報を検索します。
          <br />
          フロアマップ内の宝箱がある箇所をクリックすると中断技のタイムテーブルが確認できます。
          <hr />
          地図ランクを選択：
          <br />
          <select style={mapRankPulldownStyle} onChange={onMapRankChange} value={mapRank}>
            {mapRankList.map((s) => (
              <option key={s} value={s}>
                {'0x' + s.toString(16).padStart(2, '0').toUpperCase()}
              </option>
            ))}
          </select>
          <br />
          <br />
          地図シードを半角16進数で入力：
          <br />
          <table>
            <tbody>
              <tr>
                <td>
                  0x&thinsp;
                  <input
                    type='text'
                    style={mapSeedTextStyle}
                    maxLength={4}
                    onChange={onMapSeedChange}
                    value={mapSeed}
                  />
                </td>
                <td>
                  <button onClick={onSearchClick}>検索</button>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          結果：
          <div style={resultStyle}>{result}</div>
          <hr />
          <a href='/tools'>ツール置き場に戻る</a>
          {'　|　'}
          <a href='/'>トップページに戻る</a>
          {'　|　'}
          <a href='/blog/hello-world'>運営者情報</a>
          {'　|　'}
          <a href='/blog/privacypolicy'>プライバシーポリシー</a>
        </div>
      </div>
    </>
  )
}

export default App
